import { z } from "zod";

export const instagramPostSchema = z.object({
  schema: z.literal("amber.instagram-post/1"),
  supplier: z.string(),
  adapter: z.string(),
  observed_at: z.string(),
  post_id: z.string(),
  shortcode: z.string(),
  url: z.string(),
  author: z.object({ id: z.string(), handle: z.string(), name: z.string() }),
  created_at: z.string(),
  caption: z.string(),
  lang: z.string().nullable(),
  media: z.array(
    z.object({
      kind: z.enum(["photo", "video"]),
      url: z.string(),
      duration_ms: z.number().nullable(),
      sha256: z.string().nullable(),
      bytes: z.number().nullable(),
      archived: z.boolean(),
      note: z.string().nullable(),
    }),
  ),
  supplier_response: z.object({ sha256: z.string(), status: z.number(), observed_at: z.string() }),
});
export type InstagramPost = z.infer<typeof instagramPostSchema>;

export function instagramShortcode(url: string): string | null {
  return /instagram\.com\/(?:p|reel)\/([A-Za-z0-9_-]+)/.exec(url)?.[1] ?? null;
}
